import React from "react"
import createStandardGermanDate from "scripts/createStandardGermanDate"
import createStandardGermanDateWithTime from "scripts/createStandardGermanDateWithTime"
import doenerCase from "scripts/doenerCase"
import { Link } from "gatsby"
export const BfzEventTeaserCard = ({ event }) => {
  const { start_time, end_time, whole_day, title, is_ad } = event

  const start = whole_day
    ? createStandardGermanDate(start_time)
    : createStandardGermanDateWithTime(start_time)
  const end = whole_day
    ? createStandardGermanDate(end_time)
    : createStandardGermanDateWithTime(end_time)

  return (
    <div
      className="box is-bordered is-shadowless"
      style={{ height: "100%", position: "relative" }}
    >
      {is_ad ? (
        <div
          style={{ position: "absolute", top: 8, right: 10 }}
          className={`ad-disclaimer`}
        >
          Anzeige
        </div>
      ) : null}
      <p className="mb-2 has-text-weight-bold">
        {start}
        {end_time && " - " + end}
      </p>
      <Link
        to={`/fachzeitschriften/umweltbau/termine#${doenerCase(title)}`}
        className="title is-6"
      >
        {title}
      </Link>
    </div>
  )
}
